const DEFAULT_GOOGLE_FONTS_BUNDLE =
	"https://fonts.googleapis.com/css2?family=Anton&family=Bebas+Neue&family=League+Spartan:wght@400;700&display=swap";

const isFontStylesheetUrl = (value) => /^https?:\/\//i.test(String(value || "").trim());

const buildGoogleFontsCssUrl = (familyName) => {
	const clean = String(familyName || "")
		.trim()
		.replace(/^['"]+|['"]+$/g, "")
		.split(",")[0]
		.trim();
	if (!clean) return null;
	return `https://fonts.googleapis.com/css2?family=${encodeURIComponent(clean).replace(/%20/g, "+")}&display=swap`;
};

export function collectFontStylesheetUrls(customFonts, extraUrls = []) {
	const urls = new Set();
	[DEFAULT_GOOGLE_FONTS_BUNDLE, ...extraUrls].forEach((u) => {
		const s = String(u || "").trim();
		if (isFontStylesheetUrl(s)) urls.add(s);
	});
	(Array.isArray(customFonts) ? customFonts : []).forEach((entry) => {
		const s = String(entry || "").trim();
		if (!s) return;
		if (isFontStylesheetUrl(s)) {
			urls.add(s);
			return;
		}
		const built = buildGoogleFontsCssUrl(s);
		if (built) urls.add(built);
	});
	return Array.from(urls);
}

export function injectEscapeRoomFontLinks(urls) {
	if (typeof document === "undefined") return () => {};
	const created = [];
	(urls || []).forEach((href) => {
		const h = String(href || "").trim();
		if (!isFontStylesheetUrl(h)) return;
		if (document.querySelector(`link[data-er-font="${h}"]`)) return;
		const link = document.createElement("link");
		link.rel = "stylesheet";
		link.href = h;
		link.setAttribute("data-er-font", h);
		document.head.appendChild(link);
		created.push(link);
	});
	return () => created.forEach((l) => l.remove());
}
